import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";
import api, { formatApiErrorDetail } from "@/lib/api";

const inputCls =
  "w-full rounded-xl border border-white/12 bg-white/5 px-4 py-3 text-white placeholder:text-slate-500 focus:border-arjuna-teal focus:outline-none focus:ring-1 focus:ring-arjuna-teal/40 transition-colors duration-300";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="We'll send a secure link to reset your password."
      footer={
        <Link to="/login" data-testid="link-back-login" className="text-arjuna-teal hover:underline">
          Back to sign in
        </Link>
      }
    >
      {sent ? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-6" data-testid="forgot-sent">
          <MailCheck className="h-8 w-8 text-arjuna-agri" />
          <p className="mt-4 text-white">If an account exists for <span className="font-mono text-arjuna-teal">{email}</span>, a reset link is on its way.</p>
          <p className="mt-2 text-sm text-slate-400">Check your inbox and spam folder.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div>
            <label className="overline mb-2 block">Email</label>
            <input data-testid="forgot-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@org.in" />
          </div>
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="btn-primary w-full">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {loading ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
